<template>
  <div id="container" class="container">
    <header-component></header-component>
    <div :is="contentsName"></div>
    <footer-component></footer-component>
  </div>
</template>

<script>
  import { mapState } from 'vuex'
  import MainPage from '../components/MainPage.vue'
  import Sub1Page from '../components/Sub1Page.vue'
  import Sub2Page from '../components/Sub2Page.vue'
  import Sub3Page from '../components/Sub3Page.vue'
  import Sub4Page from '../components/Sub4Page.vue'
  import Sub5Page from '../components/Sub5Page.vue'
  import Sub6Page from '../components/Sub6Page.vue'
  import Sub7Page from '../components/Sub7Page.vue'
  import HeaderComponent from '../components/Header.vue'
  import FooterComponent from '../components/Footer.vue'

  export default {
    name: 'MainContainer',
    components: {
      MainPage,
      Sub1Page,
      Sub2Page,
      Sub3Page,
      Sub4Page,
      Sub5Page,
      Sub6Page,
      Sub7Page,
      HeaderComponent,
      FooterComponent
    },
    computed: {
      ...mapState([
        'contentsName'
      ])
    }
  }
</script>



// WEBPACK FOOTER //
// src/containers/MainContainer.vue